import { ModalBaseDirective } from '$core/base/_modal.component';
import { SwalService } from '$core/shell/swal/swal.service';
import { SwalErrorService } from '$shared/components/swal-error/swal-error.service';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Invoice } from '../../models/invoice';

@Component({
  selector: 'app-show-formed-receipt',
  templateUrl: './show-formed-receipt.component.html',
  styleUrls: ['./show-formed-receipt.component.scss'],
})
export class ShowFormedReceiptComponent
  extends ModalBaseDirective
  implements OnInit
{
  @Input() public item: Invoice;

  constructor(
    protected modalRef: BsModalRef,
    protected modalService: BsModalService,
    protected translateService: TranslateService,
    protected swalService: SwalService,
    protected swalErrorService: SwalErrorService
  ) {
    super(modalRef, modalService, translateService);
  }

  public ngOnInit(): void {
    this.modalService.setDismissReason('saved');
  }
}
